import type { AccountingPeriodListQuery, AccountingPeriodView, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';

interface AccountingPeriodsTableProps {
  page: Page<AccountingPeriodView>;
  columns: TableColumnsType<AccountingPeriodView>;
  list: ListQueryControls<AccountingPeriodListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function AccountingPeriodsTable({ page, columns, list, isRefreshing }: AccountingPeriodsTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search by date, e.g. 2026-10" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={
          list.isFiltered
            ? { emptyText: <EmptyState icon={SearchX} title="No matching periods" description="No periods match this search or these filters." /> }
            : undefined
        }
        {...list.tableProps<AccountingPeriodView>(page.total)}
      />
    </div>
  );
}
